export default "__VITE_ASSET__3jUGxb7G__"